import { bl_fm_drive_login_subject_link_RowClass, bl_fm_drive_login_subject_link_RowInterface } from "../../../dbschema/bl_fm_drive_login_subject_link.model";
import { BaseContainerModel } from "../../base-container.model";


export class DriveSubjectContainerModel extends BaseContainerModel {
  bl_fm_drive_login_subject_link: bl_fm_drive_login_subject_link_RowInterface = new bl_fm_drive_login_subject_link_RowClass();
}
